import { useField } from 'formik'
import { ChangeEvent, FocusEvent, Ref, useCallback } from 'react'
import { Input as AntdInput, InputRef as AntdInputRef } from '../../Input'
import type { PasswordProps as AntdPasswordProps } from '../../Input'
import type { FormikFieldProps } from '../typings/FieldProps'

export type PasswordProps = FormikFieldProps &
  AntdPasswordProps & {
    ref?: Ref<AntdInputRef>
  }

export const Password = ({
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  ...restProps
}: PasswordProps) => {
  const [field] = useField(name)
  const { value, onChange, onBlur } = field

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event)
      onChangeProp?.(event)
    },
    [onChange, onChangeProp]
  )

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )

  return (
    <AntdInput.Password
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
